<template>

    <div class="mother">

        <div id="app" :class="{ 'bloc-scroll': maintenance }">

            <div class="app__container">

                <navigation></navigation>

                <router-view class="app" :key="$route.path"/>

            </div>


            <maintenance :maintenance="maintenance"></maintenance>

            <modal-cookies-policy ref="mcp"></modal-cookies-policy>

            <cookie-law @manage="openCookieLaw"></cookie-law>

        </div>

        <metas></metas>

        <structured-data></structured-data>

        <optimize-trigger></optimize-trigger>

        <smart-banner></smart-banner>

        <agreements-update></agreements-update>

    </div>

</template>

<script>
import Vuex from 'vuex'

import I18n from './modules/i18n'
import Tag from './modules/tag'

import CookieLaw from './components/CookieLaw'
import Maintenance from './components/Maintenance'
import Metas from './components/Metas'
import ModalCookiesPolicy from './components/modal/ModalCookiesPolicy'
import Navigation from './components/Navigation'
import OptimizeTrigger from './components/OptimizeTrigger'
import SmartBanner from './components/SmartBanner.vue'
import StructuredData from './components/StructuredData.vue'
import AgreementsUpdate from './components/AgreementsUpdate'

import Storage from './helpers/storage'

export default {

    components: {
        AgreementsUpdate,
        CookieLaw,
        Maintenance,
        Metas,
        ModalCookiesPolicy,
        Navigation,
        OptimizeTrigger,
        SmartBanner,
        StructuredData
    },

    computed: {

        ...Vuex.mapGetters([
            'maintenance',
            'lang'
        ])

    },

    created() {

        I18n.created(this)

        const regexNative = new RegExp('^/fox/native/')
        if (!regexNative.test(this.$route.path)) {
            Tag.initTracking(this)
        }

        try {
            document.getElementById('app-speed-index').remove()
        } catch (ignored) {
            // do nothing
        }

    },

    mounted() {

        window.scrollTo(0, 1)

        // remove GTAG Page hiding snippet, fix GTAG crash
        const gtagcss = document.getElementById('gtagcss')
        if (gtagcss) {
            setTimeout(function () {
                gtagcss.remove()
            }, 2000)
        }

        const emailToDeleteRedirect = Storage.getItem('emailToDeleteRedirect')
        if(emailToDeleteRedirect) {
            Storage.removeItem('emailToDeleteRedirect')
            this.updateEmailToDeleteRedirect(emailToDeleteRedirect)
        }
    },

    methods: {

        ...Vuex.mapActions([
            'updateEmailToDeleteRedirect'
        ]),

        openCookieLaw() {

            this.$refs.mcp.open()
        }
    }
}

</script>

<style lang="scss" src="./style/main.scss"></style>

<style lang="scss" scoped>

.mother {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
}

.app {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    overflow-x: hidden;
    overflow-y: scroll;

    &__container {
        display: flex;
        flex-direction: column-reverse;
        flex-grow: 1;
        overflow: hidden;

        @media screen and (min-width: $above-tablet-length) {
            flex-direction: row;

            &:lang(ar-sa) {
                direction: rtl;
            }
        }
    }
}

.bloc-scroll {
    overflow: hidden;
}

</style>

